// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const resetAllFacets = (dealerAccounts, excluded) => ({
    dealerAccounts,
    excluded,
    type: actions.RESET_LABOR_ADDITIVE_PIP_PRODUCTS_FILTERS
});

export const toggleDealerAccountFacetItems = allowedDealers => ({
    allowedDealers,
    type: actions.TOGGLE_LABOR_ADDITIVE_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_ITEMS
});

export const updateDealerAccountFacetInput = value => ({
    type: actions.UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_INPUT,
    value
});

export const updateDealerAccountFacetItem = (dealerAccount, isSelected) => ({
    dealerAccount,
    isSelected,
    type: actions.UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_ITEM
});

export const updateShowExcludedFacetItem = selectedExcluded => ({
    selectedExcluded,
    type: actions.UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_SHOW_EXCLUDED_FACET_ITEM
});

export const initializeDealerAccountFacetItems = allowedDealers =>
    dispatch => {

        dispatch({
            allowedDealers,
            type: actions.INITIALIZE_LABOR_ADDITIVE_PIP_PRODUCTS_SHOW_EXCLUDED_FACET_ITEM
        });

        dispatch({
            allowedDealers,
            type: actions.SELECT_ALL_OPEN_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_ITEMS
        });

    };



// WEBPACK FOOTER //
// ./src/pip/labor-additive/action-creators/facets.js